import React from 'react';
import CampoEditableTexto from '../../../UI/campos/CampoEditableTexto.js';
import * as TipoEdicion from '../../../constantes/TipoEdicion.js';
import styles from '../Parametros.module.css';

const campos = {
  CODIGO: 'codigo',
  SIGLA: 'sigla',
  DESCRIPCION: 'descripcion',
};

const CamposTipoDocumento = (props) => {
  const parametro = props.parametro;
  const tipoEdicion = props.tipoEdicion;

  const onCampoChange = (nombre, valor) => {
    switch (nombre) {
      case campos.CODIGO: {
        props.onCampoChange({ ...parametro, codigo: valor });
        break;
      }
      case campos.SIGLA: {
        props.onCampoChange({ ...parametro, sigla: valor });
        break;
      }
      case campos.DESCRIPCION: {
        props.onCampoChange({ ...parametro, descripcion: valor });
        break;
      }
      default:
    }
  };

  return (
    <React.Fragment>
      <table className={`${styles.tablaDatos}`}>
        <tbody>
          <tr>
            <td className={`${styles.titulo}`}>Código</td>
            <td className={`${styles.valor}`}>
              <CampoEditableTexto
                nombre={campos.CODIGO}
                valor={parametro && parametro.codigo}
                editar={tipoEdicion === TipoEdicion.ALTA}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Sigla</td>
            <td className={`${styles.valor}`}>
              <CampoEditableTexto
                nombre={campos.SIGLA}
                valor={parametro && parametro.sigla}
                editar={tipoEdicion !== TipoEdicion.CONSULTA}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Descripción</td>
            <td className={`${styles.valor}`}>
              <CampoEditableTexto
                nombre={campos.DESCRIPCION}
                valor={parametro && parametro.descripcion}
                editar={tipoEdicion !== TipoEdicion.CONSULTA}
                onChange={onCampoChange}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </React.Fragment>
  );
};

export default CamposTipoDocumento;
